import { render, staticRenderFns } from "./PayDirectNotifications.vue?vue&type=template&id=510c3042&"
import script from "./PayDirectNotifications.vue?vue&type=script&lang=js&"
export * from "./PayDirectNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports